module.exports = __webpack_public_path__ + "static/media/expand_icon.3c4d6e14.svg";